<template>
  <tab-layout :fullWidth="true">
    <secretary-draft-details slot="tabContent" class="row mx-0 show active" />
  </tab-layout>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import TabLayout from '@/components/TabLayout'
import SecretaryDraftDetails from './SecretaryDraftDetails'

export default defineComponent({
  name: 'SecretaryDraftAdd',
  components: {
    'tab-layout': TabLayout,
    'secretary-draft-details': SecretaryDraftDetails
  },
  setup() {
    return {}
  }
})
</script>



// WEBPACK FOOTER //
// src/views/Drafts/Add/SecretaryDraftAdd.vue